export default __webpack_public_path__ + "static/media/06.0bdf7b51.png";